module.exports = __webpack_public_path__ + "img/checked-true.76364840.svg";